class DrKieuHistoryBack extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    const navigationCanGoBack = window.navigation?.canGoBack;
    const canGoBack =
      typeof navigationCanGoBack === 'boolean' ? navigationCanGoBack : window.history.length > 1;

    if (canGoBack) {
      window.history.back();
      return;
    }

    window.location.assign(this.dataset.fallbackUrl || '/');
  };
}

if (!customElements.get('dr-kieu-history-back')) {
  customElements.define('dr-kieu-history-back', DrKieuHistoryBack);
}
